export type MotionProfile = 'snappy' | 'balanced' | 'smooth';

export interface RouteTransitionSpec {
  duration: number;
  ease: [number, number, number, number];
  enterY: number;
  exitY: number;
  blurPx: number;
}

export const ROUTE_MOTION_PROFILES: Record<MotionProfile, RouteTransitionSpec> = {
  snappy: {
    duration: 0.16,
    ease: [0.2, 0.8, 0.2, 1],
    enterY: 4,
    exitY: -2,
    blurPx: 0.5,
  },
  balanced: {
    duration: 0.22,
    ease: [0.2, 0.8, 0.2, 1],
    enterY: 6,
    exitY: -4,
    blurPx: 1,
  },
  smooth: {
    duration: 0.28,
    ease: [0.16, 1, 0.3, 1],
    enterY: 8,
    exitY: -5,
    blurPx: 1.5,
  },
};

export const ACTIVE_ROUTE_MOTION_PROFILE: MotionProfile = 'balanced';
